import React from "react"
import { Dialog, FlatButton, RadioButton, RadioButtonGroup } from "material-ui"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { ETimecardPageApproveOptions, ETimecardApproveStatus } from "../../../models"
import { red500 } from "material-ui/styles/colors"
interface IProps {
    status: ETimecardApproveStatus
    allCount: number
    countOnPage: number
    close(): void
    confirm(option: ETimecardPageApproveOptions, status: ETimecardApproveStatus): void
}
interface IState {
    selectedOption: ETimecardPageApproveOptions
}

export default class ConfirmDialogForAllApproveStatus extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            selectedOption: ETimecardPageApproveOptions.ApproveStatusForPage
        }
        autobind(this)
    }

    render() {
        return (
            <div>
                <Dialog
                    title={this.props.status === ETimecardApproveStatus.Approve ? strings.Choose_Approve_All_Timecard_Option : strings.Choose_Unapprove_All_Timecard_Option}
                    actions={[
                        <FlatButton label={strings.CANCEL} primary={false} onClick={this.props.close} />,
                        <FlatButton label={strings.OK} primary keyboardFocused onClick={() => this.props.confirm(this.state.selectedOption, this.props.status)} />
                    ]}
                    modal
                    open
                    onRequestClose={this.props.close}
                >
                    <RadioButtonGroup
                        name="ConfirmDialogForAllApprove"
                        valueSelected={this.state.selectedOption}
                        onChange={(e, value) => this.setState({ selectedOption: value })}
                    >
                        <RadioButton
                            data-intercom-target={"menu-Timecards-Radio-ApproveStatusForPage"}
                            value={ETimecardPageApproveOptions.ApproveStatusForPage}
                            label={strings.formatString(this.props.status === ETimecardApproveStatus.Approve ? strings.Approve_timecards_on_this_page : strings.Unapprove_timecards_on_this_page, this.props.countOnPage)}
                            style={{ marginBottom: 16, marginLeft: 20 }}
                            iconStyle={{ width: 20, height: 20, top: 1, marginRight: 5 }}
                        />
                        <RadioButton
                            data-intercom-target={"menu-Timecards-Radio-ApproveStatusForAll"}
                            value={ETimecardPageApproveOptions.ApproveStatusForAll}
                            label={strings.formatString(this.props.status === ETimecardApproveStatus.Approve ? strings.Approve_all_timecards : strings.Unapprove_all_timecards, this.props.allCount)}
                            style={{ marginBottom: 16, marginLeft: 20 }}
                            iconStyle={{ width: 20, height: 20, top: 1, marginRight: 5 }}
                        />
                    </RadioButtonGroup>
                    <div style={{ height: 20, marginLeft: 45, color: red500 }}>
                        {this.state.selectedOption === ETimecardPageApproveOptions.ApproveStatusForAll && (this.props.status === ETimecardApproveStatus.Approve ? strings.Warning_your_timecard_will_not_approve : strings.Warning_your_timecard_will_not_unapprove)}
                    </div>
                </Dialog>
            </div>
        )
    }
}
